import { TipPipe } from './../../services/tip.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { VideoCorsiRoutingModule } from './video-corsi-routing.module';
import { VideoCorsiComponent } from './video-corsi.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [VideoCorsiComponent, TipPipe],
  imports: [
    CommonModule,
    VideoCorsiRoutingModule,
    MDBBootstrapModule.forRoot(),
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class VideoCorsiModule { }
